import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  styled,
} from "@mui/material";

export const MainAccordion = styled(Accordion)({
  padding: 0,
  backgroundColor: "inherit",
  boxShadow: "none",
  "& .MuiAccordionDetails-root": { padding: "0" },
});

export const TopicAccordion = styled(AccordionSummary)({
    padding:0
});
export const DetailAccordion = styled(AccordionDetails)({
  width:"100%",
});
